import storage from './storage';
import {ScratchSVGRender} from '@hetao/scratch-core';

const {SVGRenderer} = ScratchSVGRender
// Contains 'font-family', but doesn't only contain 'font-family="none"'
const HAS_FONT_REGEXP = 'font-family(?!="none")';

const getCostumeUrl = function (asset) {
    // If the SVG refers to fonts, they must be inlined in order to display correctly in the img tag.
    // Avoid parsing the SVG when possible, since it's expensive.
    let str;
    let p = Promise.resolve();
    if (asset.assetType === storage.AssetType.ImageVector) {
        p = asset.decodeText().then(svgString => {
            if (svgString.match(HAS_FONT_REGEXP)) {
                const svgRenderer = new SVGRenderer();
                svgRenderer.loadString(svgString);
                const svgText = svgRenderer.toString(true /* shouldInjectFonts */);
                str = `data:image/svg+xml;utf8,${encodeURIComponent(svgText)}`
            } else {
                return asset.encodeDataURI().then(res => {
                    str = res;
                })
            }
        });
    } else {
        p = asset.encodeDataURI().then(res => {
            str = res;
        });
    }
    return p.then(() => {
        return str;
    });
};

export {
    getCostumeUrl as default,
    HAS_FONT_REGEXP
};
